import { render, staticRenderFns } from "./ReadSignature.vue?vue&type=template&id=4f5dd6ee&lang=pug"
import script from "./ReadSignature.vue?vue&type=script&lang=js"
export * from "./ReadSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports